import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormattedNumber } from 'react-intl';
import TableRow from './table-row';
import IntlProviderHOC from '../app-main/containers/IntlProviderHOC';

const AttendeePricingTable = ({ listing = {} }) => {
  const tiers = get(listing, 'attendee_pricing.tiers', []);
  const currency = get(listing, 'prices.0.currency', 'USD');

  return (
    <IntlProviderHOC>
      <div>
        <h5 style={{ marginTop: '32px' }}>Attendee pricing</h5>
        <hr className="pricing-table-border" />
        <div>
          {
            tiers.length ?
              tiers.map(({ min, max, value }) => {
                return (
                  <div>
                    <TableRow
                      leftCol={
                        <div>
                          <div>{`${min} - ${max} people`}</div>
                        </div>
                      }
                      rightCol={
                        <div>
                          + <FormattedNumber
                            value={value}
                            currency={currency}
                            style="currency"
                            minimumFractionDigits={0}
                            maximumFractionDigits={0}
                          />/hr
                        </div>
                      }
                    />
                    <hr className="pricing-table-border" />
                  </div>
                );
              }) :
              <div>
                <TableRow
                  leftCol={
                    <div>
                      <div>{`${1}-${get(listing, 'number_guests')} people`}</div>
                    </div>
                  }
                  rightCol={
                    <div>
                      + <FormattedNumber
                        value={0}
                        currency={currency}
                        style="currency"
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                      />/hr
                    </div>
                  }
                />
                <hr className="pricing-table-border" />
              </div>
          }
        </div>
      </div>
    </IntlProviderHOC>
  );
};

AttendeePricingTable.propTypes = {
  listing: PropTypes.object.isRequired
};

export default AttendeePricingTable;
